import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#1A1A1A] text-[#F7F5F0] mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-2 gap-12">
        <div>
          <p className="font-serif-display text-3xl mb-3">Jack Pritchard</p>
          <p className="text-sm text-[#F7F5F0]/60 leading-relaxed max-w-xs">
            Drama, LAMDA, voice &amp; communication coaching and student speech therapist,
            helping every voice find its confidence.
          </p>
        </div>
        <div>
          <p className="label-caps text-[#D4AF37] mb-4">Explore</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/reviews" className="hover:text-[#D4AF37] transition-colors">Theatre Reviews</Link></li>
            <li><Link to="/blog" className="hover:text-[#D4AF37] transition-colors">Blog &amp; Resources</Link></li>
            <li><Link to="/gallery" className="hover:text-[#D4AF37] transition-colors">Gallery</Link></li>
            <li><Link to="/minds-chaos" className="hover:text-[#D4AF37] transition-colors">Mind's Chaos (theatre in education show)</Link></li>
            <li><Link to="/contact" className="hover:text-[#D4AF37] transition-colors">Book a Session</Link></li>
            <li><Link to="/login" className="hover:text-[#D4AF37] transition-colors">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#F7F5F0]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 text-xs text-[#F7F5F0]/40">
          © {new Date().getFullYear()} Jack Pritchard. All rights reserved.
        </div>
      </div>
    </footer>
  );
};
